import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { FieldModel, UserId } from '@cibo/core'
import { CreateLand } from '@cibo/landmanager'
import { useWindowTitle } from '@cibo/profile'
import { ResponsiveDialog } from '@cibo/ui'
import { AwaitDetails } from 'components'
import { useAppStore } from '../../store'

interface DrawFieldProps {
  onCancel: () => void
  onComplete: (props: { field: FieldModel }) => void
  onCreateEnrollment: (props: { resourceIds: string[] }) => void
  onProfile: (props: { resourceIds: string[] }) => void
  userId?: UserId
}

export const DrawField = ({
  onCancel,
  onComplete,
  onCreateEnrollment,
  onProfile,
  userId,
}: DrawFieldProps) => {
  const { t } = useTranslation('pages/DrawField')
  const [isOpen, setOpen] = useState(false)
  const [field, setField] = useState<FieldModel>()
  useWindowTitle(t('windowTitle'))
  const {
    addFieldsetField,
    fieldsetFields,
    clearFieldsetFields,
    removeFieldsetField,
  } = useAppStore()

  const handleComplete = (field?: FieldModel, isCreatingFieldset?: boolean) => {
    if (!!field) {
      if (!!fieldsetFields || isCreatingFieldset) {
        addFieldsetField(field)
      } else {
        if (!field.footprintResolved) {
          setField(field)
          setOpen(true)
        } else {
          onComplete({ field })
        }
      }
    } else if (!!fieldsetFields && !field) {
      setOpen(true)
    } else {
      onCancel()
    }
  }

  return (
    <>
      <CreateLand
        onComplete={handleComplete}
        onCancel={onCancel}
        fieldsetFields={fieldsetFields}
        setSensingDialogOpen={setOpen}
        userId={userId}
        removeFieldsetField={removeFieldsetField}
        clearFieldsetFields={clearFieldsetFields}
      />
      <ResponsiveDialog open={isOpen} maxWidth="xs" onClose={() => setOpen(false)}>
        <AwaitDetails
          created
          fieldIds={
            fieldsetFields
              ? fieldsetFields.map(field => field.resourceId)
              : field
              ? [field.resourceId]
              : []
          }
          onCompleteProfile={fieldIds => {
            clearFieldsetFields()
            onProfile({ resourceIds: fieldIds })
          }}
          onCreateEnrollment={fieldIds => {
            clearFieldsetFields()
            onCreateEnrollment({ resourceIds: fieldIds })
          }}
          onSkipDetails={() => {
            clearFieldsetFields()
            onCancel()
          }}
        />
      </ResponsiveDialog>
    </>
  )
}
